import angular from "angular";
import template from "./admin-school-edit-campus.html";
import AdminSchoolLocationEditController from "./admin-school-edit-campus.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.schools.view.locations.edit", {
    url: "/edit/:locationId",
    controller: AdminSchoolLocationEditController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.schools.view.locations.edit", [])
  .config(config)
  .controller(
    "AdminSchoolLocationEditController",
    AdminSchoolLocationEditController,
  );
